import { Button, List, ListItem, ListItemText, Stack } from '@mui/material'
import { SectionHeader } from '@sitoo/mui-components'
import { useTranslation } from 'react-i18next'
import { ListItemSkeleton } from '../../../../components/list-item-skeleton'
import { PaymentType, PosPaymentMethod } from '../../../../generated/graphql'
import { PaymentMethodIcon } from '../payment-method-icon'
import { RootRoute } from '../../..'
import { Link as RouterLink } from 'react-router-dom'
import { useMemo } from 'react'
import { useAbsolutePath } from '../../../../hooks/absolute-path'

type Props = {
  isLoading?: boolean
  paymentOption?: PaymentType
}

export const Method = (props: Props) => {
  const { t } = useTranslation(['payment_options'])
  const { isLoading, paymentOption } = props
  const generatePath = useAbsolutePath()
  const settingsLink = useMemo(() => {
    const paymentMethod = paymentOption?.paymentmethodid

    switch (paymentMethod) {
      case PosPaymentMethod.KLARNA:
        return RootRoute.AppsKlarna
      case PosPaymentMethod.CARD_SOFTPAY:
        return RootRoute.AppsSoftpay
      case PosPaymentMethod.SWISH:
      case PosPaymentMethod.SWISH_WITH_QR:
        return RootRoute.AppsSwish
      case PosPaymentMethod.VIPPS_MOBILEPAY:
        return RootRoute.AppsVippsMobilePay
      default:
        return undefined
    }
  }, [paymentOption?.paymentmethodid])

  return (
    <>
      <SectionHeader>{t('payment_options:method')}</SectionHeader>

      <List>
        {isLoading && (
          <ListItemSkeleton
            isLoading={isLoading}
            secondaryAction="-"
            childrenSkeleton
          />
        )}

        {!isLoading && paymentOption && (
          <ListItem>
            <PaymentMethodIcon paymentOption={paymentOption} fontSize="large" />

            <ListItemText
              primary={t(
                `payment_options:payment_method.${paymentOption.paymentmethodid}`,
              )}
              slotProps={{
                primary: {
                  sx: {
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                  },
                },

                secondary: {
                  whiteSpace: 'nowrap',
                },
              }}
            />
          </ListItem>
        )}
      </List>

      {settingsLink && (
        <Stack padding={2}>
          <Button
            color="secondary"
            size="small"
            to={generatePath(settingsLink)}
            component={RouterLink}
          >
            {t('payment_options:edit_app_configuration')}
          </Button>
        </Stack>
      )}
    </>
  )
}
